module.exports = __webpack_public_path__ + "img/IT0002733876882.17fed0e7.png";